import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BudgetItemApi } from 'api';

import { RootState } from '../app';

export const findBudgetItem = createAsyncThunk(
  'budgetItem/findBudgetItem',
  async (_, { rejectWithValue }) => {
    try {
      const response = await BudgetItemApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  isInitData: boolean;
  entityDocumentSubCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả chứng từ',
    },
  ],
  isInitData: false,
  entityDocumentSubCategoriesHash: {},
};

const budgetItemSlice = createSlice({
  name: 'budgetItem',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findBudgetItem.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: budgetItemReducer } = budgetItemSlice;

export default budgetItemReducer;

export const selectBudgetItem = (state: RootState): IState =>
  state.budgetItem as IState;
